import { getActionTitle, getDefaultButtonLabel } from '../../../layout/widgets/adaChat/actionPermissions'

/**
 * Map tool names to action types
 */
export const mapToolNameToActionType = (toolName: string): string | null => {
  const toolToActionMap: Record<string, string> = {
    run_auto_design: 'autoDesignEphemeral',
    save_system_design_as_template: 'saveSystemDesignAsTemplate',
    navigate: 'navigate',
    load_auto_design_result: 'loadAutoDesignResult',
    undo_redo: 'undoRedo',
  }
  return toolToActionMap[toolName] || null
}

/**
 * Convert tool call to buttonAction format
 * Note: Labels are kept as translation keys and will be translated where they're displayed (e.g., in ActionConfirmation)
 */
export const convertToolCallToButtonAction = (toolCall: {
  toolName: string
  arguments: any
  timestamp: number
}): any | null => {
  const actionType = mapToolNameToActionType(toolCall.toolName)
  if (!actionType) {
    // Only include client-side tools that map to actions
    return null
  }

  // Get default button label from action permissions (these are translation keys)
  const defaultLabel = getDefaultButtonLabel(actionType) || getActionTitle(actionType) || 'Action'

  return {
    action: {
      action: actionType,
      args: toolCall.arguments,
    },
    label: defaultLabel, // Translation key, will be translated in ActionConfirmation
    isCollapsed: true, // Already executed, so show as collapsed
    confirmedActionLabel: defaultLabel, // Translation key, will be translated in ActionConfirmation
  }
}
